import { Text, Box } from "agrofy-ui-components";
import React from "react";
import CollapsibleToggler from "../../CollapsibleToggler/CollapsibleToggler";
import "./PaymentMethodItem.scss";
import styled from 'styled-components';

const PaymentMethodItem = (props) => {

  const title =
    props.item.Name + (props.item.Message ? " | " + props.item.Message : "");
  
  const showCollapseBtn =  props.item.Rates?.length > 0;

  return (
    <CollapsibleToggler
      title={title}
      titleType="subtitle-lg"
      titleClass="heading-xs"
      titleColor="gray9"
      collapsed={true}
      showCollapseBtn={showCollapseBtn}
      image={props.item.Image}
      lastItem={props.isLast}
      subtitle={props.item.Description}
    >
      {props.item.Rates?.length > 0 && (<>
        <TableContainer display='flex' justify-content='center' ma='sm'>
          <table>
            <thead>
              <tr>
                <th><Text weight="600">{props.item.Code === 'credit_card_agro' ? 'Plazos' : 'Cuotas'}</Text></th>
                <th><Text weight="600">C.F.T.</Text></th>
              </tr>
            </thead>
            <tbody>
              {props.item.Rates.map((x, index) =>
                (<>
                  <tr key={`${props.item.Id}-${index}`}>
                    <td><Text pa='xxs' type='body-md'>{props.item.Code === 'credit_card_agro' ? x.name : x.numberOfInstallments}</Text></td>
                    <td><Text pa='xxs' type='body-md'>{x.cft}</Text></td>
                  </tr>
                </>)
              )}
            </tbody>
          </table>
        </TableContainer>
      </>)}
    </CollapsibleToggler>
  );
};

export default PaymentMethodItem;

const TableContainer = styled(Box)``;